import { render, staticRenderFns } from "./company-benefit-item.vue?vue&type=template&id=b3ceb052&scoped=true"
import script from "./company-benefit-item.vue?vue&type=script&lang=js"
export * from "./company-benefit-item.vue?vue&type=script&lang=js"
import style0 from "./company-benefit-item.vue?vue&type=style&index=0&id=b3ceb052&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ceb052",
  null
  
)

export default component.exports